import { useQuery } from "@tanstack/react-query";
import { api } from "../documentation";
export const GET_OBJECT_INFO_KEY = "get-object-info";

export const useGetObjectInfo = (id: string | undefined) => {
    const { data, isFetching } = useQuery({
        queryKey: [GET_OBJECT_INFO_KEY, id],
        queryFn: () => api.GetObjectInfo(id!),
        enabled: !!id
    });

    return {
        data, 
        isFetching
    }
}